import { createRouter, createWebHistory } from "vue-router";

import AreaLogin from "./pages/AreaLogin.vue";
import ListaProdutos from "./pages/ListaProdutos.vue";
import UserCarrinho from "./pages/UserCarrinho.vue";
import BarCode from "./pages/BarCode.vue";
import ClienteForm from "./pages/ClienteForm.vue";
import ProdutoPage from "./pages/ProdutoPage.vue";
import CategoriaPage from "./pages/CategoriaPage.vue";
import BuscaPage from "./pages/BuscaPage.vue";
import MeusPedidos from "./pages/MeusPedidos.vue";
import MinhaConta from "./pages/MinhaConta.vue";
import ResumoPedido from "./pages/ResumoPedido.vue";
import EsquecerSenha from "./pages/EsquecerSenha.vue";

const router = createRouter({
  history: createWebHistory("/erp/"),
  routes: [
    { path: "/:tokenTipo/:tokenLoja/login", component: AreaLogin, props: true },
    {
      path: "/:tokenTipo/:tokenLoja/carrinho",
      component: UserCarrinho,
      props: true,
    },
    { path: "/:tokenTipo/:tokenLoja/barcode", component: BarCode, props: true },
    {
      path: "/:tokenTipo/:tokenLoja/cadastro",
      component: ClienteForm,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/recuperarsenha",
      component: EsquecerSenha,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/produtos",
      component: ListaProdutos,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/produtos/meuspedidos",
      component: MeusPedidos,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/produtos/minhaconta",
      component: MinhaConta,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/checkout",
      component: ResumoPedido,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/produtos/:tokenProduto",
      component: ProdutoPage,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/produtos/categorias/:tokenCategoria",
      component: CategoriaPage,
      props: true,
    },
    {
      path: "/:tokenTipo/:tokenLoja/produtos/busca/:tokenBusca",
      component: BuscaPage,
      props: true,
    },
  ],
});

export default router;
